





























































import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import CsvSelector from '@/trials/views/components/CsvSelector.vue';
import DragDrop from '@/trials/views/components/DragDrop.vue';
import ProgressItem from '@/trials/views/components/ProgressItem.vue';
import DataTable from '@/trials/views/components/DataTable.vue';

@Component({ components: { CsvSelector, DragDrop, ProgressItem, DataTable } })
export default class TrainDataUpload extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/

    /*----------------------------------*
     * Data
     *-----------------------------------*/

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    // KC取得 可能フラグ(0件以上の学習データの投入を確認する)
    private get isListable(): boolean {
        return sessionModule.getTrainingData !== null;
    }

    // ファイルアップロード可能かどうか
    private get canUpload(): boolean {
        return sessionModule.getTrainingDataUploaded === SC.Flag.Process.TODO;
    }

    private get trainData() {
        const trainData = sessionModule.getTrainingData;
        if (trainData === null) {
            return [];
        }

        return trainData.data;
    }

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    /*----------------------------------*
     * Methods
     *-----------------------------------*/
}
